import React, {useEffect, useState} from 'react'
import { Message, State } from './types';
import {GoogleMapsProvider} from 'plugin-extension-google/shared/GoogleMaps/GoogleMapsProvider'
import { getApiWebKey } from './api/google-integration';
import CovaregeMap from './CoverageMap';

const WidgetCovaregeMap = (props: LiveReactWidgetImplProps<State, Message>): JSX.Element => {
    const { widget, state } = props
    const {zoom, extensionQualifier} = widget.jsonConfig
    const [googleMapsApiKey, setGoogleMapsApiKey] = useState<string>()       

    useEffect(() => {
        getApiWebKey(extensionQualifier).then(res => {
            setGoogleMapsApiKey(res)
        })
    }, [extensionQualifier])

    return (
        <GoogleMapsProvider zoom={zoom} googleMapsApiKey={googleMapsApiKey}>
            {
                !state.stop && <div className="loading" />
            }

            {state.stop && <CovaregeMap {...props}/>}
        </GoogleMapsProvider>
    )
}

export default WidgetCovaregeMap;